import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';

function Login() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    document.title = "Hotel Atlanta | Login";
  }, []);

  const handleLogin = (e) => {
    e.preventDefault();

    if (username === 'admin@atlanta.com' && password === '123456') {
      localStorage.setItem('isLoggedIn', 'true');
      localStorage.setItem('currentUser', 'admin');
      alert("Admin logged in successfully!");
      navigate('/');
      return;
    }

    const users = JSON.parse(localStorage.getItem('users')) || [];
    const userMatch = users.find(user => user.username === username && user.password === password);

    if (userMatch) {
      localStorage.setItem('isLoggedIn', 'true');
      localStorage.setItem('currentUser', userMatch.username);
      alert("Login successful!");
      navigate('/');
    } else {
      alert("Invalid credentials.");
    }
  };

  return (
    <section id="contact-form" className="py-3" style={{ minHeight: 'calc(100vh - 140px)' }}>
      <div className="container" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', height: '100%' }}>
        <h1 className="l-heading">
          <span className="text-primary">Login</span> Page
        </h1>
        <p>Enter your credentials to proceed.</p>
        <form onSubmit={handleLogin}>
          <div className="form-group">
            <label htmlFor="username">Username</label>
            <input
              type="text"
              id="username"
              required
              placeholder="Enter username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
            />
          </div>
          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input
              type="password"
              id="password"
              required
              placeholder="Enter password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>
          <button type="submit" className="btn">Login</button>
        </form>

        <div style={{ marginTop: '20px', textAlign: 'left' }}>
  <p>New user?</p>
  <Link to="/signup" className="btn btn-light">Sign Up</Link>
</div>
      </div>
    </section>
  );
}

export default Login;